import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconRefresh.tsx
const OutlinedFilledRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-479.75q0-142.76 101-244.5Q334-826 477-826q91 0 160.39 36.72Q706.79-752.55 757-687v-139h72v291H537v-71h164q-39-56-94-90.5T477-731q-105.25 0-178.12 72.82-72.88 72.83-72.88 178Q226-375 298.88-302q72.89 73 178.15 73 77.97 0 144.47-45T716-393h97q-30 115-123.26 186.5Q596.49-135 477-135Z" })
});
const OutlinedRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-479.75q0-142.76 101-244.5Q334-826 477-826q91 0 160.39 36.72Q706.79-752.55 757-687v-139h72v291H537v-71h164q-39-56-94-90.5T477-731q-105.25 0-178.12 72.82-72.88 72.83-72.88 178Q226-375 298.88-302q72.89 73 178.15 73 77.97 0 144.47-45T716-393h97q-30 115-123.26 186.5Q596.49-135 477-135Z" })
});
const RoundedFilledRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-480q0-143 101-244.5T477-826q91 0 160.5 36.5T757-687v-103q0-15.4 9.8-25.7Q776.6-826 793-826q15.4 0 25.7 10.3Q829-805.4 829-790v208q0 20-14 33.5T781-535H572q-14.97 0-24.99-10.3Q537-555.6 537-571q0-14.97 10.3-24.99Q557.6-606 573-606h128q-39-56-94.09-90.5Q551.83-731 477-731q-105 0-178 73t-73 178q0 105 73 178t178 73q67 0 126-33.5t92-91.5q10.62-16.16 28.81-23.08Q742-384 759.74-376 778-369 785-352.5t-1 32.5q-44 85-126.5 135T477-135Z" })
});
const RoundedRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-480q0-143 101-244.5T477-826q91 0 160.5 36.5T757-687v-103q0-15.4 9.8-25.7Q776.6-826 793-826q15.4 0 25.7 10.3Q829-805.4 829-790v208q0 20-14 33.5T781-535H572q-14.97 0-24.99-10.3Q537-555.6 537-571q0-14.97 10.3-24.99Q557.6-606 573-606h128q-39-56-94.09-90.5Q551.83-731 477-731q-105 0-178 73t-73 178q0 105 73 178t178 73q67 0 126-33.5t92-91.5q10.62-16.16 28.81-23.08Q742-384 759.74-376 778-369 785-352.5t-1 32.5q-44 85-126.5 135T477-135Z" })
});
const SharpFilledRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-479.75q0-142.76 101-244.5Q334-826 477-826q91 0 160.39 36.72Q706.79-752.55 757-687v-139h72v291H537v-71h164q-39-56-94-90.5T477-731q-105.25 0-178.12 72.82-72.88 72.83-72.88 178Q226-375 298.88-302q72.89 73 178.15 73 77.97 0 144.47-45T716-393h97q-30 115-123.26 186.5Q596.49-135 477-135Z" })
});
const SharpRefresh = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M477-135q-143 0-244-101T132-479.75q0-142.76 101-244.5Q334-826 477-826q91 0 160.39 36.72Q706.79-752.55 757-687v-139h72v291H537v-71h164q-39-56-94-90.5T477-731q-105.25 0-178.12 72.82-72.88 72.83-72.88 178Q226-375 298.88-302q72.89 73 178.15 73 77.97 0 144.47-45T716-393h97q-30 115-123.26 186.5Q596.49-135 477-135Z" })
});
const componentMap = {
	outlined: OutlinedRefresh,
	"outlined-fill": OutlinedFilledRefresh,
	rounded: RoundedRefresh,
	"rounded-fill": RoundedFilledRefresh,
	sharp: SharpRefresh,
	"sharp-fill": SharpFilledRefresh
};
const IconRefresh = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t("icon.refresh"),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconRefresh };